import { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollBackground from './components/ScrollBackground';
import ScrollToTop from './ScrollToTop';
import ErrorFallback from './pages/ErrorFallback';
import LoadingSpinner from './pages/LoadingSpinner';

// Lazy load all page components
const Home = lazy(() => import('./pages/Home'));
const About = lazy(() => import('./pages/About'));
const Technology = lazy(() => import('./pages/Technology'));
const Products = lazy(() => import('./pages/Products'));
const Contact = lazy(() => import('./pages/Contact'));
const PrivactPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const TermsOfService = lazy(() => import('./pages/TermsOfService'));
const CookiesPolicy = lazy(() => import('./pages/CookiesPolicy'));
const Careers = lazy(() => import('./pages/Careers'));
const UnderDevelopment = lazy(() => import('./pages/UnderDevelopment'));

function App() {
  return (
    <Router>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <div className="min-h-screen flex flex-col relative text-slate-600">
          <ScrollBackground />
          <div className="relative z-10 flex flex-col min-h-screen flex-grow">
          <Navbar />
          <ScrollToTop />
          <main className="flex-grow">
            <Suspense fallback={<LoadingSpinner fullPage />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/technology" element={<Technology />} />
                <Route path="/products" element={<Products />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/privacy" element={<PrivactPolicy />} />
                <Route path="/terms" element={<TermsOfService />} />
                <Route path="/cookies" element={<CookiesPolicy />} />
                <Route path="/careers" element={<Careers />} />
                <Route path="/under-development" element={<UnderDevelopment />} />
                {/* Catch-all route for undefined paths */}
                <Route path="*" element={<Navigate to="/under-development" replace />} />
              </Routes>
            </Suspense>
          </main>
          <Footer />
          </div>
        </div>
      </ErrorBoundary>
    </Router>
  );
}

export default App;